<template>
  <div class="fade-in">
    <h1 class="title">Create a Provider</h1>

    <form @submit.prevent="onSubmit" class="account-form">
      <formly-form :form="form" :model="doctor" :fields="fields"></formly-form>

      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Create
          </button>
        </div>
        <div class="control">
          <router-link
            :to="{ name: 'user-list', params: { id } }"
            class="button is-link"
            >Cancel
          </router-link>
        </div>
      </div>
    </form>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import ReferralDoctorService from "@/services/ReferralDoctorService";
import DoctorFields from "@/components/interview/DoctorFields";

export default {
  name: "interview-providers-create",

  mixins: [DoctorFields],

  props: ["id"],

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      doctor: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        interviewId: this.id
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      ReferralDoctorService.create(this.doctor)
        .then(() => {
          this.loading = false;
          this.$router.push({
            name: "interview-providers",
            params: { id: this.$props.id }
          });
          this.$refs.toastr.s("The provider has been created.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error creating the provider.");
        });
    }
  }
};
</script>

<style lang="scss"></style>
